var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"copy-right"},[_c('p',[_vm._v("©2023-"+_vm._s(_vm.dateNow)+" "),_c('span',[_vm._v("AI-Flow")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }